import { useAppStore } from '@/modules/global/stores/AppStore'

/**
 * How the document canvas renders (canvas load 1.6).
 *
 * - `interactive`: a person is viewing or editing. Blocks may render statically and create editors, load embeds
 *   and mount lazily when needed.
 * - `export`: the PDF service is capturing the page (print mode, `?printMode=true`). Nothing can be clicked, focused
 *   or scrolled into view before the capture, so **export mounts everything** and never waits for interaction:
 *   lazy mounting (Phase 2) must check this and mount every block, embeds show a print card instead of a player,
 *   and nothing creates an editor on demand. Work the capture must wait for goes through export-readiness.ts.
 *
 * Derived from `AppStore.isInPrintMode`, the single flag for it; components read it as the `canvasRenderMode`
 * getter through `mapState`.
 */
export type CanvasRenderMode = 'interactive' | 'export'

// Called while editors and the static renderer build their DOM, which must not throw when no store is active
export function getCanvasRenderMode(): CanvasRenderMode {
  try {
    return useAppStore().canvasRenderMode
  } catch {
    return 'interactive'
  }
}

export function isExportMode(): boolean {
  return getCanvasRenderMode() === 'export'
}
